import { render, staticRenderFns } from "./LocationTemplateUpdate.vue?vue&type=template&id=35dbe492&scoped=true"
import script from "./LocationTemplateUpdate.vue?vue&type=script&lang=js"
export * from "./LocationTemplateUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dbe492",
  null
  
)

export default component.exports